export const en = {
    'selected-groups-count': {
        one: '{count} category selected',
        some: '{count} categories selected',
        many: '{count} categories selected',
        none: 'Select categories'
    },
    'video-preview-header': 'Preview',
    'video-title': 'Video library'
};
